// extracted by mini-css-extract-plugin
module.exports = {"d2xZ8":"Z8_d2xZ8__PpAWu"};